import { render } from "./AddFactoryModal.vue?vue&type=template&id=fd70d434&scoped=true"
import script from "./AddFactoryModal.vue?vue&type=script&lang=js"
export * from "./AddFactoryModal.vue?vue&type=script&lang=js"

import "./AddFactoryModal.vue?vue&type=style&index=0&id=fd70d434&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd70d434"]])

export default __exports__